// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lS48","content":"styles_content__MRiOg","tableWrap":"styles_tableWrap__3R8cO"};